import type { SportSpec, WireState } from './wire';

export interface ClockConfig {
  period_count: number;
  period_length: number;
  clock_direction: 'down' | 'up';
  period_label: string;
  break_length: number;
  extra_period_count: number;
  extra_period_length: number;
  timeout_length: number | null;
}

export type ClockMatchState = 'running' | 'paused' | 'break' | 'timeout';

export interface ClockState extends WireState {
  match_state: ClockMatchState;
  period: { current: number; total: number };
  timings: { period_time: number; interval_time: number; synced_at?: number };
}

export const PERIOD_CLOCK = 'period_time';
export const INTERVAL_CLOCK = 'interval_time';

export const clockSpec: SportSpec<ClockConfig, ClockState> = {
  type: 'clock',
  clocks: (config) => [
    {
      name: PERIOD_CLOCK,
      direction: config.clock_direction,
      runsIn: ['running'],
    },
    { name: INTERVAL_CLOCK, direction: 'down', runsIn: ['break', 'timeout'] },
  ],
  runningStateOf: (state) => state.match_state,
};

export const periodStart = (config: ClockConfig, extra: boolean): number => {
  const length = extra ? config.extra_period_length : config.period_length;

  return config.clock_direction === 'down' ? length : 0;
};
